import React, { memo, HTMLAttributes } from 'react'
import { AutocompleteRenderOptionState, createStyles, makeStyles } from 'transfix-ui/core'
import { IAutocompleteBaseOption } from '../../types'
import { OptionAvatar } from './components/OptionAvatar'
import { OptionDescription } from './components/OptionDescription'
import { OptionIcon } from './components/OptionIcon'
import { OptionMarkup } from './components/OptionMarkup'

export interface IAutocompleteOptionProps<T extends IAutocompleteBaseOption>
  extends HTMLAttributes<HTMLLIElement> {
  option: T
  state: AutocompleteRenderOptionState
}

const useAutocompleteOptionStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
  })
)

/**
 * Used for <Autocomplete />'s `renderOption` prop
 */
const AutocompleteOption = memo(function AutocompleteOption<T extends IAutocompleteBaseOption>({
  option,
  state,
  ...props
}: IAutocompleteOptionProps<T>) {
  const { inputValue } = state || {}
  const { description, descriptionClassName, iconName, optionType = 'default', text = '' } =
    option || {}
  const classes = useAutocompleteOptionStyles()
  const showIcon = ['withIcon', 'withIconAndDescription'].includes(optionType)
  const showDecription = optionType === 'withIconAndDescription'
  return (
    <li className={classes.root} data-test='Autocomplete-option' {...props}>
      {optionType === 'withAvatar' && <OptionAvatar text={text} />}
      {showIcon && iconName && <OptionIcon iconName={iconName} />}
      <OptionMarkup inputValue={inputValue} text={text} />
      {showDecription && description && (
        <OptionDescription description={description} className={descriptionClassName} />
      )}
    </li>
  )
})

export default AutocompleteOption
